export const REPORTS_TRANSLATIONS = {
  Reports: "Rapports",

  lastReports: "{{count}} derniers rapports",
  lastReports_zero: "Aucun rapport disponible",
  lastReports_one: "Dernier rapport",

  report_type_farm_animals: "Rapport Général des Animaux",
  report_type_individual_animal: "Rapport Individuel d'Animal",
  report_type_farm: "Rapport de Ferme",
  report_type_apiary: "Rapport de Rucher",
  report_type_crops: "Rapport de Cultures",
  newReport: "Nouveau Rapport",
  download: "Télécharger",
  view: "Voir",
  generateReport: "Générer le Rapport",
}
